/**
 * @doc https://github.com/xyxiao001/vue-cropper/blob/main/english.md
 */
import Vue from 'vue';
import VueCropper from 'vue-cropper';

Vue.use(VueCropper);
